import { render } from "./ForgotPasswordPopup.vue?vue&type=template&id=139e16bc&ts=true"
import script from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__